var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubbleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.85254H13.75M6.25 10.3525H10M1.875 11.6103C1.875 12.9446 2.81118 14.1059 4.13122 14.3C5.07164 14.4383 6.0227 14.5438 6.98321 14.6155C7.27504 14.6372 7.54181 14.7903 7.70413 15.0337L10 18.4775L12.2958 15.0338C12.4582 14.7903 12.7249 14.6373 13.0168 14.6155C13.9773 14.5439 14.9283 14.4384 15.8687 14.3001C17.1888 14.106 18.125 12.9447 18.125 11.6104V6.59467C18.125 5.26042 17.1888 4.09906 15.8687 3.90498C13.9534 3.62338 11.9938 3.47754 10.0002 3.47754C8.00647 3.47754 6.04676 3.62341 4.13122 3.90506C2.81118 4.09915 1.875 5.26051 1.875 6.59474V11.6103Z",
    stroke: "#5C37EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleIcon);
export default __webpack_public_path__ + "static/media/chat-bubble-icon.035b0ca3766c3f9e0740ba1e45c7daa1.svg";
export { ForwardRef as ReactComponent };